module.exports = __webpack_public_path__ + "img/gift.5fa7a54b.svg";